import './App.css';
import React, { Suspense, lazy, useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import About from "./pages/about";
import Contact from "./pages/contact";
import Servicepage from "./pages/service";
import Portfolio from "./pages/portfolio";
import Blog from "./pages/blog";
import FullPost from "./components/blogpost";
import Projectimages from "./components/projectcomponent/projectoverview/terex";
import Projectimages1 from "./components/projectcomponent/projectoverview/kayjay";
import Projectimages2 from "./components/projectcomponent/projectoverview/asrresidence";
import Projectimagesars2 from "./components/projectcomponent/projectoverview/asr2";
import Projectimages3 from "./components/projectcomponent/projectoverview/relaxinn";
import Projectimages4 from "./components/projectcomponent/projectoverview/ephepany";
import Projectimages5 from "./components/projectcomponent/projectoverview/church1";
import Projectimages6 from "./components/projectcomponent/projectoverview/church2";
import Projectimages7 from "./components/projectcomponent/projectoverview/manjunatha";
import Inframat from "./components/projectcomponent/projectoverview/inframat";

//church
import Church1 from "./components/projectcomponent/projectoverview2.jsx/church/churchconference";
import Church2 from "./components/projectcomponent/projectoverview2.jsx/church/infantjesus";
import Church3 from "./components/projectcomponent/projectoverview2.jsx/church/stpiuschurch";
import Church4 from "./components/projectcomponent/projectoverview2.jsx/church/sebastianchurch";
import Church5 from "./components/projectcomponent/projectoverview2.jsx/church/orthodoxchurch";
import Church6 from "./components/projectcomponent/projectoverview2.jsx/church/lourdeschurch";
import Church7 from "./components/projectcomponent/projectoverview2.jsx/church/anthonychurch";

import Ivdp from "./components/projectcomponent/projectoverview2.jsx/industry/ivdp";
import Ivdpshg from "./components/projectcomponent/projectoverview2.jsx/industry/ivdpshg";
import Amala from "./components/projectcomponent/projectoverview2.jsx/school/amalaschool";

//commercial
import Shuttle from "./components/projectcomponent/projectoverview2.jsx/commercial/shuttlecourt";
import Lake from "./components/projectcomponent/projectoverview2.jsx/commercial/hosurlake";
import Yercaud from "./components/projectcomponent/projectoverview2.jsx/commercial/yercaudhotel";

//retreatcenter and residential
import Edward from "./components/projectcomponent/projectoverview2.jsx/residential/edward";
import Muni from "./components/projectcomponent/projectoverview2.jsx/residential/munirathnam";
import Venkatesh from "./components/projectcomponent/projectoverview2.jsx/residential/venkatesh";
import Sam from "./components/projectcomponent/projectoverview/sam";
import Carmel from "./components/projectcomponent/projectoverview2.jsx/retreatcenter/carmel";
import Donbosco from "./components/projectcomponent/projectoverview2.jsx/retreatcenter/donbosco";

import { motion } from 'framer-motion';
import Whatsapp from "./components/whatsappbutton";
import Industry from "./pages/industry";

// Lazy load Home component
const Home = lazy(() => import("./pages/home"));

const Loading = ({ onComplete }) => {
  const words = ["SAMSON", "&", "ASSOCIATES", "since 1972"];
  const [displayText, setDisplayText] = useState("");
  const [wordIndex, setWordIndex] = useState(0);
  const [letterIndex, setLetterIndex] = useState(0);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    if (wordIndex < words.length) {
      const word = words[wordIndex];

      if (letterIndex < word.length) {
        const timer = setTimeout(() => {
          setDisplayText(prev => prev + word[letterIndex]);
          setLetterIndex(letterIndex + 1);
        }, 50);

        return () => clearTimeout(timer);
      } else {
        const nextWordTimer = setTimeout(() => {
          setDisplayText(prev => prev + " \n");
          setLetterIndex(0);
          setWordIndex(wordIndex + 1);
        }, 100);

        return () => clearTimeout(nextWordTimer);
      }
    } else {
      setTimeout(() => {
        setCompleted(true);
        onComplete();
      }, 1000);
    }
  }, [wordIndex, letterIndex, words, onComplete]);

  return (
    <motion.div
      className="loading-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <h1 className="typing-text">{displayText}</h1>
    </motion.div>
  );
};

const AppContent = () => {
  const location = useLocation();
  const [isHomeLoading, setIsHomeLoading] = useState(location.pathname === "/");

  useEffect(() => {
    if (location.pathname !== "/") {
      setIsHomeLoading(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {isHomeLoading ? (
        <Loading onComplete={() => setIsHomeLoading(false)} />
      ) : (
        <motion.div
          initial={{ y: 1500, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1.5 }}
        >
          <Suspense fallback={null}>
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/about' element={<About />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/projects' element={<Portfolio />} />
              <Route path='/service' element={<Servicepage />} />
              <Route path='/blog' element={<Blog />} />
              <Route path='/industries' element={<Industry/>} />
              <Route path='/terexindia' element={<Projectimages />} />
              <Route path='/kayjayforgingsprivatelimited' element={<Projectimages1 />} />
              <Route path='/asrresidence' element={<Projectimages2 />} />
              <Route path='/asr2' element={<Projectimagesars2 />} />
              <Route path='/relaxinnresort' element={<Projectimages3 />} />
              <Route path='/ephepanyconventionalhall' element={<Projectimages4 />} />
              <Route path='/selliyampattiinfantjesuschurch' element={<Projectimages5 />} />
              <Route path='/poondimadhachurch' element={<Projectimages6 />} />
              <Route path='/manjunathatheater' element={<Projectimages7 />} />
              <Route path='/ChruchConferenceHall,SacredHeartNovitiate,Eachinkadu' element={<Church1 />} />
              <Route path='/Infantjesus-Selliampatti' element={<Church2 />} />
              <Route path='/St.PiusThirumandhuraiChurch' element={<Church3 />} />
              <Route path='/St.Sebastianpoolapattidharmapuri' element={<Church4 />} />
              <Route path='/OrthodoxChurchandMissionCenter-Hosur' element={<Church5 />} />
              <Route path='/St.Lourdes-Hosur' element={<Church6 />} />
              <Route path='/St.AnthonychurchBilligundu' element={<Church7 />} />
              <Route path='/IVDPoffice' element={<Ivdp />} />
              <Route path='/IVDPSHGsindustrialtrainingcenter' element={<Ivdpshg />} />
              <Route path='/amalaschool-dharumapuri' element={<Amala />} />
              <Route path='/shuttlecourt' element={<Shuttle />} />
              <Route path='/Hosurramanayakanlakewalkerslanemeditationhall' element={<Lake />} />
              <Route path='/mr.edwardresident' element={<Edward />} />
              <Route path='/mr.munirathnamresident' element={<Muni />} />
              <Route path='/mr.venkateshresident' element={<Venkatesh />} />
              <Route path='/carmelretreatcenter' element={<Carmel />} />
              <Route path='/donbosco' element={<Donbosco />} />
              <Route path='/casatainnyercaud' element={<Yercaud />} />
              <Route path='/samresidence' element={<Sam />} />
              <Route path='/inframatfactoryunit' element={<Inframat />} />
              <Route path="/post/:postId" element={<FullPost />} />
            </Routes>
          </Suspense>

          {/* WhatsApp Button */}
          <Whatsapp />
        </motion.div>
      )}
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
